module.exports = __webpack_public_path__ + "static/img/VDappScenarios3-2.75cf268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDappScenarios3-2.png
// module id = IzSJ
// module chunks = 0